/**
 * Location 定位资源配置
 * @type {{}}
 */
import Vue from "vue";
import { Input, Icon, Message, Modal, Button, Dropdown, DropdownMenu, DropdownItem,Select,Option } from "view-design";
Vue.component('Input', Input);
Vue.component('Icon', Icon);
Vue.component('Modal', Modal);
Vue.component('Button', Button);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Select', Select);
Vue.component('Option', Option);
import { getLocationClassAllService,
    addLocationClassService,
    updateLocationClassService,
    upgradeLocationClassService,
    delLocationClassService,
    locationTypeMoveService} from '@/service/location-service'
import { mapMutations, mapState } from "vuex";
import $event, { EVENT_NAME } from "@/utils/event-emitter";
const Location = {
    name:'Location',
    computed: {
        ...mapState({
            locationSelectedMenuId: state => state.system.locationSelectedMenuId, //选中的菜单Id
            menuVisible: state => state.system.menuVisible, //菜单显示状态
        }),
    },
    data() {
        return {
            windowWidth:window.innerWidth, //获取窗口宽度
            locationModalVisible:false, //定位分类modal弹框可显示
            locationLoading:false, //定位分类modal弹框 loading
            locationListArray:[], //定位分类数据
            locationTypeList:[], //定位分类二级数据
            locationName:'', //定位目录名称
            locationId:'', //定位id
            locationType:'', //定位分类
            btnStatus:false, //按钮状态
        }
    },
    created() {
        if(this.locationSelectedMenuId === undefined){
            this.SET_LOCATION_SELECTED_MENU_ID([])
        }
        if(this.locationSelectedMenuId.length!==0){
            this.$router.push('/location/list')
        }
        if(this.locationSelectedMenuId.length === 0){
            this.SET_LOCATION_SELECTED_MENU_ID([-1,'',''])
        }
        this.onLocationClassAll().then()
        console.log(this.locationSelectedMenuId)
    },
    methods: {
        ...mapMutations('system',['SET_LOCATION_MENU_ARRAY','SET_LOCATION_SELECTED_MENU_ID']),

        /**
         * 跳转携带id
         * @param id
         */
        onLinks(deviceId,childrenId,childId){
            this.SET_LOCATION_SELECTED_MENU_ID([-1,childrenId,childId])
            if(this.$route.path!=='/location/list'){
                this.$router.push('/location/list')
            }else{
                $event.$emit(EVENT_NAME.LOCATION_MENU_LIST)
            }
        },
        /**
         * 添加根结点定位目录
         */
        onAddLocation(){
            this.btnStatus = true
            this.locationModalVisible = true
            this.locationName = ''
            this.locationId = ''
        },
        /**
         * 添加定位分类验证
         */
        onAddLocationCheck(){
            if(this.locationName === ''){
                Message.error('请输入定位名称！')
                return;
            }
            this.btnStatus?this.onAddLocationClass().then():this.onUpdateLocationClass().then()

        },
        /**
         * 添加二级目录
         * @param id
         */
        onChildAddLocation(id){
            this.btnStatus = true
            this.locationModalVisible = true
            this.locationName = ''
            this.locationId = id
        },
        /**
         * 修改定位目录
         * @param id
         */
        onUpdateLocation(obj,type){
            this.btnStatus = false
            this.locationModalVisible = true
            this.locationName = obj.label
            this.locationId = obj.value
            this.locationType = type
        },
        /**
         * 升级设备分类
         * @param id
         */
        onUpgradeDevice(id){
            this.onUpgradeDeviceClass(id).then()
        },
        /**
         * 删除设备
         * @param id
         */
        onDelLocation(id){
            Modal.confirm({
                title: '提示',
                content: '<p>您确定要删除吗？</p>',
                loading:true,
                onOk: () => {
                    this.onDelLocationClass(id).then()
                }
            });
        },
        /**
         * 移动定位目录
         * @param id
         * @param type
         */
        onSortableLocation(id,type){
            this.onLocationTypeMoveService(id,type).then()
        },
        /**
         * 添加定位分类
         * @returns {Promise<void>}
         */
        async onAddLocationClass(){
            try {
                this.locationLoading = true
                let params = {
                    parentId:this.locationId,
                    name:this.locationName,
                }
                const { code } = await addLocationClassService(params)
                if(code === 'SUCCESS'){
                    this.locationName = ''
                    this.locationId = ''
                    Message.success('添加成功！')
                    this.onLocationClassAll().then()
                    this.locationModalVisible = false
                }else if(code === 'LOCATION_CATALOGUE_NAME_ALREADY_EXISTS'){
                    Message.error('请勿重复添加定位目录名称！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.locationLoading = false

            }catch (error){
                this.locationLoading = false
                console.log(error)
            }
        },
        /**
         * 修改定位目录
         * @returns {Promise<void>}
         */
        async onUpdateLocationClass(){
            try {
                this.locationLoading = true
                let params = {
                    id:this.locationId,
                    name:this.locationName,
                    parentId:this.locationType
                }
                const { code } = await updateLocationClassService(params)
                if(code === 'SUCCESS'){
                    this.locationName = ''
                    this.locationId = ''
                    Message.success('修改成功！')
                    this.onLocationClassAll().then()
                    this.locationModalVisible = false
                }else if(code === 'LOCATION_CATALOGUE_NAME_ALREADY_EXISTS'){
                    Message.error('请勿重复添加定位目录名称！')
                }else if(code === 'LOCATION_CATALOGUE_EXISTENCE_DATA'){
                    Message.error('您修改的目录下存在其他目录，请移除后重试！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.locationLoading = false

            }catch (error){
                this.locationLoading = false
                console.log(error)
            }
        },
        /**
         * 升级设备分类
         * @returns {Promise<void>}
         */
        async onUpgradeDeviceClass(id){
            try {
                let params = {
                    id:id,
                }
                const { code } = await upgradeLocationClassService(params)
                if(code === 'SUCCESS'){
                    Message.success('升级成功！')
                    this.onDeviceClassAll().then()
                }else if(code === 'EQUIPMENT_CLASSIFICATION_NODE_REPEAT_NAME'){
                    Message.warning('目录名称重复，请更改后重试！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 删除定位目录
         * @returns {Promise<void>}
         */
        async onDelLocationClass(id){
            try {
                this.locationLoading = true
                let params = {
                    id:id,
                }
                const { code } = await delLocationClassService(params)
                if(code === 'SUCCESS'){
                    Message.success('删除成功！')
                    this.onLocationClassAll().then()
                }else if(code === 'LOCATION_CATALOGUE_EXISTENCE_DATA'){
                    Message.error('此目录下存在其他目录，不可删除！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.locationLoading = false
                Modal.remove();
            }catch (error){
                Modal.remove();
                this.locationLoading = false
                console.log(error)
            }
        },
        /**
         * 获取所有定位目录
         */
        async onLocationClassAll() {
            try {
                const { code,data } = await getLocationClassAllService()
                if(code === 'SUCCESS'){
                    let array = [data]
                    for(let i in array){
                        array[i].name = '目录'
                        array[i].visible = true
                        array[i].id = -1
                        if(array[i].childNode.length!==0){
                            for(let j in array[i].childNode){
                                array[i].childNode[j].visible = true
                            }
                        }
                    }
                    this.locationListArray = this.onReplaceAttribute(array)
                    this.locationTypeList = this.locationListArray[0].children
                    this.SET_LOCATION_MENU_ARRAY(this.locationListArray)
                    console.log(this.locationTypeList)
                }else{
                    Message.error('请求异常，请联系管理员！')
                }

            }catch (error){
                console.log(error)
            }
        },
        /**
         * 定位目录移动排序
         */
        async onLocationTypeMoveService(id,moveType) {
            try {
                let params = {
                    id:id,
                    moveType:moveType,
                }
                const { code } = await locationTypeMoveService(params)
                if(code === 'SUCCESS'){
                    this.onLocationClassAll().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 替换属性名
         * @param data
         */
        onReplaceAttribute(data){
            let item = []
            data.map(list => {
                let newData = {}
                newData.value = list.id;
                newData.label = list.name;
                newData.visible = list.visible;
                newData.children = list.childNode;
                if(list.childNode){
                    newData.children = this.onReplaceAttribute(list.childNode)
                }
                item.push(newData)
            })
            return item
        },
    },
    destroyed () {
    }
}
export default Location
